<template>
  <div id="detailProductDigitalMenu">
    <i class="icons-menu close_icon_modal" @click="$parent.close()"></i>
    <div class="detail-product-digital-menu-container">
      <div v-if="dataProduct.isImage === 1" class="detail-product-digital-menu-container__img" :style="`background-image: url('${getProductsImageLang(dataProduct, 'onlyImage')}'); height: ${getProductsImageLang(dataProduct, 'onlyImage') ? '300px;': '0px;'}`"></div>
      <div v-else class="detail-product-digital-menu-container__img" :style="`background-image: url('${getProductsImageLang(dataProduct, 'image')}');height: ${getProductsImageLang(dataProduct, 'image') ? '300px;': '0px;'}`"></div>
      <div class="detail-product-digital-menu-container__info">
        <h3>{{dataProduct.name}}</h3>
        <div class="detail-product-digital-menu-container__info__description" v-html="dataProduct.description"></div>
        <div class="detail-product-digital-menu-container__info__restrictions" v-if="dataProduct.dietaryRestrictions && dataProduct.dietaryRestrictions.length > 0">
          <div>Restricciones alimentarias</div>
          <div class="detail-product-digital-menu-container__info__restrictions__icons">
            <span class="logoDietaryRestrictions" v-for="(restriction, index) in dataProduct.dietaryRestrictions" :style="{'mask-image':`url(${restriction.iconURL})`}" :key="index">
            </span>
          </div>
        </div>
        <div class="detail-product-digital-menu-container__info__prices">
          <h3 v-if="isTwoPrices && dataProduct.priceTwo > 0">Precios</h3>
          <div class="detail-product-digital-menu-container__info__prices__container">
            <div v-if="isTwoPrices && dataProduct.priceTwo > 0">
              <span>Precio Izquierda</span>
              <span>{{dataProduct.priceTwo | currency("$ ", 0, { thousandsSeparator: "," })}}</span>
            </div>
            <div :class="{ 'detail-product-digital-menu-container__info__prices__container__flex': !isTwoPrices || dataProduct.priceTwo <= 0}">
              <span>Precio {{isTwoPrices && dataProduct.priceTwo > 0 ? 'Derecha' : ''}}</span>
              <span>{{dataProduct.price | currency("$ ", 0, { thousandsSeparator: "," })}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['dataProduct', 'getProductNameByLang', 'getProductsImageLang', 'isTwoPrices']
};
</script>

<style lang="scss">
  .modal-detail-product-digital-menu{
    .animation-content{
      max-width: 390px!important;
      max-height: 553px!important;
      border-radius: 6px;
      overflow: hidden;
      width: 100%;
    }
    #detailProductDigitalMenu{
      position: relative;
      .detail-product-digital-menu-container{
        max-height: 553px;
        overflow: auto;
        position: relative;
        &__img{
          border-radius: 6px;
          background-repeat: no-repeat;
          background-size: cover;
          background-position: center center;
        }
        &__info{
          padding: 20px;
          h3{
            text-align: center;
            font-size: 16px;
            margin-bottom: 8px;
          }
          &__description{
            max-height: 72px;
            overflow-y: auto;
            &::-webkit-scrollbar-thumb {
              background-color: #F4EFE9;
              border-radius: 99rem;
            }
            &::-webkit-scrollbar {
              width: 3px;
            }
          }
          p{
            font-size: 12px;
          }
          &__restrictions{
            border-radius: 6px;
            margin: 0 auto;
            margin-top: 20px;
            max-width: 300px;
            width: fit-content;
            min-height: 26px;
            display: flex;
            gap: 20px;
            font-size: 10px;
            font-style: normal;
            font-weight: 400;
            align-items: center;
            padding: 7px 27px;
            > div:first-child{
              white-space: nowrap;
            }
            &__icons{
              flex-wrap: wrap;
              display: flex;
              gap: 6px;
              .logoDietaryRestrictions{
                mask-size: contain;
                mask-position: center;
                mask-repeat: no-repeat;
                height: 14px;
                width: 18px;
                display: block;
              }
            }
          }
          &__prices{
            margin-top: 20px;
            h3{
              font-size: 14px;
            }
            &__container{
              display: flex;
              justify-content: center;
              gap: 20px;
              &__flex{
                align-items: center!important;
                gap: 20px;
                display: flex!important;
              }
              & > div {
                display: grid;
                span:first-child{
                  font-size: 10px;
                  font-weight: 400;
                }
                span:nth-child(2){
                  font-size: 14px;
                  font-weight: 700;
                }
              }
            }
          }
        }
      }
    }
  }
</style>
